import { headerAuth } from "../standardAuthPatterns";
import { productVariant } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";

export const blackDuckPolarisPlatform = productVariant({
  identifier: "blackDuckPolarisPlatform",
  authLabel: "Polaris Platform",
  protocol: "http",
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://polaris.blackduck.com"),
  auth: headerAuth([
    { name: "Api-token", value: { from: "secret", field: "apiToken" } },
  ]),
  steps: [
    {
      title: "Set up Black Duck Polaris",
      items: [
        {
          kind: "markdown",
          content:
            "In Polaris, open **Account → Access Tokens** and create a token. Enter it below. The connection test reads your organization’s portfolio ID. See the [API quickstart](https://polaris.blackduck.com/developer/default/documentation/t_api-quickstart).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "url",
          label: "API base URL",
          required: true,
          defaultValue: "https://polaris.blackduck.com",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use https://polaris.blackduck.com for tenants migrated to the current Black Duck domain. The official quickstart also documents the legacy https://polaris.synopsys.com domain for tenants that have not migrated; confirm the tenant URL with the account administrator.",
        },
        {
          kind: "input",
          label: "Polaris API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText:
            "Create a Polaris access token from Profile name → Account → Access Tokens → Create New Token. Polaris displays the token only at creation time.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://polaris.blackduck.com")
          .trim()
          .replace(/\/+$/, "") + "/api/portfolios/",
      method: "GET",
      headers: { Accept: "application/vnd.polaris.portfolios-1+json" },
    }),
  },
});
